import { motion } from "framer-motion";
import AnimatedCounter from "@/components/AnimatedCounter";

const stats = [
  { value: 12, suffix: "+", label: "Websites shipped" },
  { value: 100, suffix: "%", label: "Solo-built" },
  { value: 7, prefix: "<", suffix: "d", label: "Typical MVP time" },
  { value: 5.0, decimals: 1, suffix: "/5", label: "Client satisfaction" },
];

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="border-y border-white/10 bg-[#0C0C0C]/60"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-2 lg:grid-cols-4">
        {stats.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.55, delay: i * 0.08 }}
            className={`py-12 lg:py-16 ${
              i < stats.length - 1 ? "lg:border-r border-white/10" : ""
            } ${i < 2 ? "border-b lg:border-b-0 border-white/10" : ""}`}
          >
            <div className="px-6 lg:px-10">
              <div className="font-display text-5xl lg:text-7xl font-medium text-[#E2FF31] tracking-tight">
                <AnimatedCounter
                  value={s.value}
                  decimals={s.decimals || 0}
                  prefix={s.prefix || ""}
                  suffix={s.suffix || ""}
                  testId={`stat-value-${i}`}
                />
              </div>
              <div className="mt-3 font-mono-tag text-[10px] text-white/50">
                {s.label}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
